import { inject } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ApplicationService } from "@core/data/application.service";
import { ApplicationProgressSharedService } from "@core/data/application-progress-shared.service";
import { map, switchMap } from "rxjs/operators";
import { AppConstants } from "@core/constants/app";
import { ApplicationProgressResponse } from "@core/interfaces/api-responses";

export function ApplicationIntroGuardFn(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const applicationProgressSharedService: ApplicationProgressSharedService = inject(ApplicationProgressSharedService);
    const applicationService: ApplicationService = inject(ApplicationService);
    const router: Router = inject(Router);

    applicationProgressSharedService.clearData();
    const stateParam = router.getCurrentNavigation()?.extras.state;
    const pageRefreshed = router.getCurrentNavigation()?.extras?.replaceUrl;
    if (!stateParam?.requestedEffectiveDate || pageRefreshed) {
        router.navigate([AppConstants.ELIGIBILITY_CHECK_PAGE]);
        return false;
    }
    const applicationId = stateParam.application?.id;
    if (!applicationId) {
        return true;
    }
    return applicationService.getProgress(applicationId).pipe(
        switchMap((stepsProgress: ApplicationProgressResponse) => {
            applicationProgressSharedService.sendData(stepsProgress);
            return applicationProgressSharedService.getData();
        }),
        map((stepsProgress: ApplicationProgressResponse) => {
            if (stepsProgress?.submissionStatus) {
                router.navigate([`${AppConstants.CONFIRMATION_PAGE}/${stepsProgress.id}`]);
                return false;
            }
            if (!stepsProgress) {
                router.navigate([AppConstants.ELIGIBILITY_CHECK_PAGE]);
                return false;
            }
            return true;
        }),
    );
}
